<template>
    <div class="text-right">
        <button id="btnDashboardFilter" v-b-toggle.collapse_filter class="btn btn-outline-primary" type="button" title="Add Filter">
            <i class="fal fa-filter"></i>
        </button>
        <b-collapse id="collapse_filter" class="mt-2">
            <b-card>
                <div class="row text-left">
                    <div class="col-sm-12 col-lg-auto">
                        <p class="card-text mb-1">{{ $t('label.records_for') }}</p>
                        <div class="row">
                            <div class="col-sm-12 col-md col-lg-auto">
                                <div class="form-group">
                                    <div class="input-group" style="min-width:200px">
                                        <div class="input-group-prepend w-100">
                                            <label class="input-group-text border-right-0" for="serviceCategory">
                                                <i class="fas fa-calendar-alt"></i>
                                            </label>
                                            <multiselect id="selectLastYear" v-model="selectedLastYearOption" :options="lastYearOption" :searchable="false" :show-labels="false" :placeholder="$t('label.year')" @select="setThisYearOption"></multiselect>
                                        </div>
                                    </div>
                                    <div id="errLastYear" class="error-validation"></div>
                                </div>
                            </div>
                            <div class="col-auto input-group-append d-flex align-items-center">
                                <span>{{ $t('label.and') }}</span>
                            </div>
                            <div class="col-sm-12 col-md col-lg-auto">
                                <div class="form-group">
                                    <div class="input-group" style="min-width:200px">
                                        <div class="input-group-prepend w-100">
                                            <label class="input-group-text border-right-0" for="serviceCategory">
                                                <i class="fas fa-calendar-alt"></i>
                                            </label>
                                            <multiselect id="selectThisYear" v-model="selectedThisYearOption" :options="thisYearOption" :searchable="false" :show-labels="false" :placeholder="$t('label.year')"></multiselect>
                                        </div>
                                    </div>
                                    <div id="errThisYear" class="error-validation"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 col-xl-3">
                        <div class="form-group mt-4">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect v-model="selectedOutletOption" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below">
                                        <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg text-right mt-4">
                        <button type="button" class="btn btn-primary waves-effect waves-themed" @click="filterDashboard">{{ $t('button_link.apply') }}</button>
                    </div>
                </div>
            </b-card>
        </b-collapse>
    </div>
</template>
<script>
import { get } from 'http'
import moment from 'moment'
import { getOutletList } from './../../assets/js/dashboard/dashboard'
export default {
    name: 'dashboardInfoFilter',
    props: {
        selectedThisYear: Number,
        selectedLastYear: Number,
        selectedOutlet: Object,
        outlet: Array,
    },
    watch: {
        "$i18n.locale"(val) {
            this.outlet = [{ id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) }]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutletOption = this.outlet.filter(obj => obj.id == b.id)
        },
        selectedThisYear(val) {
            this.selectedThisYearOption = val
        },
        selectedLastYear(val) {
            this.selectedLastYearOption = val
            this.setThisYearOption(val)
        },
        selectedOutlet(val) {
            if(!this.selectedOutletOption) {
                this.selectedOutletOption = val
                this.filterDashboard()
            } else {
                this.selectedOutletOption = val
            }
        },
    },
    data() {
        return {
            lastYearOption: [],
            thisYearOption: [],
            selectedLastYearOption: parseInt(moment().subtract(1, 'year').startOf('year').format('YYYY')),
            selectedThisYearOption: parseInt(moment().startOf('year').format('YYYY')),
            selectedOutletOption: null,
        }
    },
    methods: {
        setThisYearOption(value) {
            const year = moment().get('year')
            this.thisYearOption = Array.from({ length: year - value }, (_, index) => year - index)

            if (this.selectedThisYearOption <= value) {
                this.selectedThisYearOption = value + 1
            }
        },
        filterDashboard() {
            var filterObj = {
                thisYear: this.selectedThisYearOption,
                lastYear: this.selectedLastYearOption,
                outlet: this.selectedOutletOption,
            }
            this.$emit('filterDashboard', filterObj)
        },
    },
    async mounted() {
        const year = moment().get('year')
        this.lastYearOption = Array.from({ length: year - 1969 }, (_, index) => year - index - 1)
        this.setThisYearOption(year - 1)

        if(!this.selectedOutletOption) {
            if(this.outlet.length > 0) {
                this.selectedOutletOption = this.outlet[0]
                this.filterDashboard()
            }
        }
    },
}
</script>